import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Form, Row } from "react-bootstrap";
import { centerConstants, translationConstants } from "../../../../constants";

const NafeesTab = ({ nafeesApproved, setNafeesApproved }) => {
  const { t } = useTranslation();

  return (
    <Container className="mt-4em">
      <Row>
        <Col md={12}>
          <Container className="d-flex justify-content-center align-items-center flex-column">
            <hr className="verticalLine mb-0" />
            <p className="font-weight-600 font-14 mt-4em">
              {t(translationConstants.IS_NAFES_APPROVED)}
            </p>
            <div className="align-items-center nafees-approval-container">
              <Form.Group className="w-100">
                <div className="d-flex radio-button w-100 justify-content-around">
                  <Form.Check
                    inline
                    type="radio"
                    name="nafeesBtn"
                    id="inline-radio-1"
                    value={translationConstants.YES}
                    label={t(translationConstants.YES)}
                    onChange={(e) => setNafeesApproved(e.target.value)}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    name="nafeesBtn"
                    id="inline-radio-2"
                    value={translationConstants.NO}
                    label={t(translationConstants.NO)}
                    onChange={(e) => setNafeesApproved(e.target.value)}
                  />
                </div>
              </Form.Group>
            </div>
            {nafeesApproved === translationConstants.NO && (
              <div className="text-center mt-4em">
                <p className="font-14">
                  {t(translationConstants.NEED_NAFES_APPROVAL)}
                </p>
                <p className="font-14">
                  {t(translationConstants.NAFES_LINK_TEXT)}
                </p>
                <a
                  href={process.env.REACT_APP_NAFES_URL}
                  className="font-14"
                  target="_blank"
                >
                  {t(translationConstants.NAFES_APPROVAL_TEXT)}
                </a>
              </div>
            )}
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default NafeesTab;
